import { convertNumberToCurrency } from '../../../utils';

export const countryData = [
  {
    key: 'australia',
    displayName: 'Australia',
    currency: 'Australian Dollar',
    code: 'AUD',
    link: undefined,
    symbol: '$',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'canada',
    displayName: 'Canada',
    currency: 'Canadian Dollar',
    code: 'CAD',
    link: undefined,
    symbol: '$',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'czech republic',
    displayName: 'Czech Republic',
    currency: 'Czech Koruna',
    code: 'CZK',
    link: undefined,
    symbol: 'Kč',
    swiftFee: 5.5,
    localNetworkFee: 0.9,
    includeInCalculator: true
  },
  {
    key: 'denmark',
    displayName: 'Denmark',
    currency: 'Danish Krone',
    code: 'DKK',
    link: undefined,
    symbol: 'kr',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'euro zone',
    displayName: 'Euro Zone',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: true
  },
  {
    key: 'austria',
    displayName: 'Austria',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'belgium',
    displayName: 'Belgium',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'cyprus',
    displayName: 'Cyprus',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: false
  },
  {
    key: 'estonia',
    displayName: 'Estonia',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'finland',
    displayName: 'Finland',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'france',
    displayName: 'France',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'germany',
    displayName: 'Germany',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'greece',
    displayName: 'Greece',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'ireland',
    displayName: 'Ireland',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'italy',
    displayName: 'Italy',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'latvia',
    displayName: 'Latvia',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'lithuania',
    displayName: 'Lithuania',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'luxembourg',
    displayName: 'Luxembourg',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'netherlands',
    displayName: 'Netherlands',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'poland',
    displayName: 'Poland',
    currency: 'Polish Zloty',
    code: 'PLN',
    link: '/send-money-abroad/send-money-to-poland/',
    symbol: 'zł',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: true
  },
  {
    key: 'portugal',
    displayName: 'Portugal',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'slovakia',
    displayName: 'Slovakia',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'slovenia',
    displayName: 'Slovenia',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'spain',
    displayName: 'Spain',
    currency: 'Euro',
    code: 'EUR',
    link: undefined,
    symbol: '€',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: false
  },
  {
    key: 'hong kong',
    displayName: 'Hong Kong',
    currency: 'Hong Kong Dollar',
    code: 'HKD',
    link: undefined,
    symbol: '$',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'hungary',
    displayName: 'Hungary',
    currency: 'Hungarian Forint',
    code: 'HUF',
    link: undefined,
    symbol: 'Ft',
    swiftFee: 5.5,
    localNetworkFee: 0.9,
    includeInCalculator: true
  },
  {
    key: 'new zealand',
    displayName: 'New Zealand',
    currency: 'New Zealand Dollar',
    code: 'NZD',
    link: undefined,
    symbol: '$',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'norway',
    displayName: 'Norway',
    currency: 'Norwegian Krone',
    code: 'NOK',
    link: undefined,
    symbol: 'kr',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'romania',
    displayName: 'Romania',
    currency: 'Romanian New Leu',
    code: 'RON',
    link: undefined,
    symbol: 'lei',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'singapore',
    displayName: 'Singapore',
    currency: 'Singapore Dollar',
    code: 'SGD',
    link: undefined,
    symbol: '$',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'south africa',
    displayName: 'South Africa',
    currency: 'South African Rand',
    code: 'ZAR',
    link: '/send-money-abroad/send-money-to-south-africa/',
    symbol: 'R',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'sweden',
    displayName: 'Sweden',
    currency: 'Swedish Krona',
    code: 'SEK',
    link: undefined,
    symbol: 'kr',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'switzerland',
    displayName: 'Switzerland',
    currency: 'Swiss Franc',
    code: 'CHF',
    link: undefined,
    symbol: 'fr',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'turkey',
    displayName: 'Turkey',
    currency: 'Turkish Lira',
    code: 'TRY',
    link: undefined,
    symbol: '₺',
    swiftFee: 5.5,
    localNetworkFee: undefined,
    includeInCalculator: true
  },
  {
    key: 'united states',
    displayName: 'United States',
    currency: 'US Dollar',
    code: 'USD',
    link: undefined,
    symbol: '$',
    swiftFee: 5.5,
    localNetworkFee: 0.3,
    includeInCalculator: true
  }
];

export let sendExchangeTableCategories = {};

export let sendExchangeTableData = { Currency: {}, Code: {}, SWIFT: {}, 'Local network fee': {} };

countryData
  //filter to remove euroZone from country-fees table
  .filter((country) => country.key !== 'euro zone')
  .forEach((country) => {
    sendExchangeTableCategories[country.displayName] = country.link
      ? `<a href="${country.link}">${country.displayName}</a>`
      : country.displayName;
  });

countryData
  //filter to remove euroZone from country-fees table
  .filter((country) => country.key !== 'euro zone')
  .forEach((country) => {
    sendExchangeTableData.Currency[country.displayName] = country.currency;
    sendExchangeTableData.Code[country.displayName] = country.code;
    sendExchangeTableData.SWIFT[country.displayName] = convertNumberToCurrency(country.swiftFee, 'en-GB', 'GBP');
    sendExchangeTableData['Local network fee'][country.displayName] =
      country.localNetworkFee !== undefined ? convertNumberToCurrency(country.localNetworkFee, 'en-GB', 'GBP') : 'n/a';
  });
